<template>
  <form-wizard ref="add_pkb_form" color="#39C0ED"   @on-complete="addConfirmation">
      <h2 slot="title"></h2>
      <!-- <tab-content title="Service info" :before-change="()=>validateStep('childServiceInfoComponent')"> -->
        <tab-content  title="Service info" :before-change="()=>validateStep('childServiceInfoComponent')">
          <info-card v-if="pkb.length != 0" @keluhanServiceSparepart="dataServiceSparepart" :pkb="pkb" ref="childServiceInfoComponent"/>
        </tab-content>
      <tab-content title="Keluhan dan Analisa" >
        <keluhan-card @data="dataKeluhan" :pkb="pkb" ref="childKeluhanComponent"/>         
      </tab-content>
      <tab-content title="Check Kelengkapan">
          <kelengkapan-card :pkb="pkb" ref="childKelengkapanComponent"/>         
        </tab-content>   
        
        <!-- <tab-content title="Service dan Sparepart">
          <serviceSparepart-card :pkb="pkb" v-if="pkb.length != 0" ref="childServiceSparepartComponent"/>
        </tab-content>
          -->
      <tab-content title="Service" :before-change="()=>validateStep('childServiceComponent')">
        <service-card @data="dataService" :pkb="pkb" ref="childServiceComponent"/>
      </tab-content>
      <tab-content title="Spare Part" :before-change="()=>validateStep('childPartComponent')">
        <part-card @data="dataPart" :pkb="pkb" ref="childPartComponent"/>
      </tab-content>

    </form-wizard>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import InfoCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/InfoCardPKB.vue";
  import KeluhanCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/KeluhanCard.vue";
  import KelengkapanCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/KelengkapanCard.vue";
  //import ServiceSparepartCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/ServiceSparepartCard.vue";
  import ServiceCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/ServiceCard.vue";
  import PartCard from "@/pages/Dashboard/Workshop/PKB/ComponentForm/PartCard.vue";
  import Swal from 'sweetalert2';
  export default {
    name: "edit-pkb",

    

     components: {
      //ValidationError,
      FormWizard,
      TabContent,
      "info-card": InfoCard,
      "keluhan-card": KeluhanCard,
      "kelengkapan-card": KelengkapanCard,
      //"serviceSparepart-card": ServiceSparepartCard
      "service-card": ServiceCard,
      "part-card": PartCard,
      },

      props: {
    data_id: null,
    },

    mixins: [formMixin],

   data: () => ({
      pkb : [],
    }),

    created() {
      this.getPkbData();
    },


    methods: {
      //fungsi yang dijalankan pertama kali saat page dibuka
      async getPkbData(){
          //check id ikut terkirim di route
        if(this.data_id.id){
          
        //console.log(this.data_id.id)
        //ambil data di server sesuai dengan data id yang ada di route
        await this.$store.dispatch("workshop_pkb/get", this.data_id.id)

         //set value bersarkan data yang yang diterima dari server
        this.pkb = await this.$store.getters["workshop_pkb/pkb"]
        
        if(this.pkb.pkb_spion == 1){
         this.pkb.pkb_spion = true
        }
        if(this.pkb.pkb_battery_1 == 1){
         this.pkb.pkb_battery_1 = true
        }
        if(this.pkb.pkb_battery_2 == 1){
         this.pkb.pkb_battery_2 = true
        }
        if(this.pkb.pkb_rak_depan == 1){
         this.pkb.pkb_rak_depan = true
        }
        if(this.pkb.pkb_rak_belakang == 1){
         this.pkb.pkb_rak_belakang = true
        }
        
         this.pkb.pkb_teknisi = this.pkb.pkb_teknisi_name.id
        //  this.pkb.pkb_service_advisor = this.pkb.pkb_service_advisor_name.id

        
        
        //console.log(this.pkb);
        }
        else{
          //jika null kembali keserver
          // await this.$router.replace({name: 'List PKB'});
          this.$parent.$parent.modalCloseEdit();
        }
      },


      async addConfirmation() {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.updatePkb()
        }
      });
    },

      //fungsi update pkb
      async updatePkb() {
        //ambil data dari child page
        this.$refs.childKeluhanComponent.getData()
        this.$refs.childServiceComponent.getData()
         this.$refs.childPartComponent.getData()

    

        
        const data = {
          id: this.pkb.id,
          type: "workshop_pkbs",
           pkb_no: this.pkb.pkb_no,
          pkb_datetime: this.pkb.pkb_datetime,
          pkb_spion: this.pkb.pkb_spion,
          pkb_battery_1: this.pkb.pkb_battery_1,
          pkb_battery_2: this.pkb.pkb_battery_2,
          pkb_rak_depan: this.pkb.pkb_rak_depan,
          pkb_rak_belakang: this.pkb.pkb_rak_belakang,
          
          pkb_service_estimate_id	: this.pkb.pkb_service_estimate_id,
          pkb_repeat_order: this.pkb.pkb_repeat_order,
          pkb_keluhan: this.pkb.keluhan,
          pkb_service: this.pkb.service,
          pkb_part: this.pkb.part,
          pkb_catatan: this.pkb.pkb_catatan,
          pkb_perintah_kerja: this.pkb.pkb_perintah_kerja,
          pkb_teknisi: this.pkb.pkb_teknisi,
          // pkb_service_advisor: this.pkb.pkb_service_advisor,
          pkb_payment_plan: this.pkb.pkb_payment_plan,
          pkb_work_order_type: this.pkb.pkb_work_order_type
        }
        //console.log(data)

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_pkb/update", data)
           //panggil alert succes
          await this.$store.dispatch("alerts/success", "Pkb data changed successfully.")
          //kembali kelist
          // await this.$router.replace({name: 'List PKB'});
          this.$parent.$parent.modalCloseEdit();
          //this.$refs['password_form'].reset()
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      },
      ///get data from child
      dataServiceSparepart (value) {
          // console.log(value) 
          // console.log("ahahahah") 
          //set data di child dengan menjalankan fungsi getDataParent 
          this.$refs.childKeluhanComponent.getDataParent(value.keluhan)
          this.$refs.childServiceComponent.getDataParent(this.pkb.pkb_service,'edit')
          this.$refs.childPartComponent.getDataParent(this.pkb.pkb_part,'edit')
         

      },

      //set data yang diambil dari child keluhan
      dataKeluhan (value) {
        this.pkb.keluhan = value
        // console.log(value)
        //  console.log("value")
      },
       //set data yang diambil dari child service
      dataService (value) {
        this.pkb.service = value
      },
       //set data yang diambil dari child part
      dataPart (value) {
         console.log(value) 
        this.pkb.part = value
      },
      
      //checke validasi stiap child sebulum pindah section
      validateStep(name) {
      var refToValidate = this.$refs[name]
       return refToValidate.validateForm()
    },
    }
  };
</script>
